import * as types from './actionTypes'

export const getProfile = () => {
    return {
        type: types.GET_PROFILE_REQUEST
    }
}

